// extracted by mini-css-extract-plugin
export var headerCell = "_49-1";
export var loadingSpinnerContainer = "_49-4";
export var rowWrapper = "_49-3";
export var standaloneTable = "_49-5";
export var table = "_49-0";
export var white = "_49-2";